import { render, staticRenderFns } from "./UjianProcess.vue?vue&type=template&id=a25e5798&scoped=true"
import script from "./UjianProcess.vue?vue&type=script&lang=js"
export * from "./UjianProcess.vue?vue&type=script&lang=js"
import style0 from "./UjianProcess.vue?vue&type=style&index=0&id=a25e5798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25e5798",
  null
  
)

export default component.exports